"use client"

/**
 * BI Behavioral Telemetry Beacon
 * Captures conversion KPIs and pushes to the global data layer safely.
 */
export const trackTelemetry = (eventName: string, payload: Record<string, any> = {}) => {
  if (typeof window === "undefined") return;

  if (process.env.NODE_ENV === "development") {
    console.info(`[BI KPI TRACKER] :: ${eventName}`, payload);
  }

  // Agnostic Data Layer Push (Compatible with Vercel Analytics, GTM, etc.)
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    ...payload,
    timestamp: new Date().toISOString(),
  });
}

// Ensure TypeScript recognizes the global dataLayer
declare global {
  interface Window {
    dataLayer: any[];
  }
}